import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'

import './MenuItem.css'

export const MenuItem = ({
  nestedModifierName,
  description,
  calories,
  imageUrl,
  onRemoveModifier
}) => {
  return (
    <div>
      {nestedModifierName && <h3 styleName='nestedName'>{nestedModifierName}</h3>}
      <p data-testid='modifier-item-description' styleName='description'>{description}</p>
      {calories > 0 && <p data-testid='modifier-item-calories' styleName='calories'>{calories} Calories</p>}
      {imageUrl && (
        <div
          data-testid='modifier-image-url'
          styleName='image'
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      )}
      {onRemoveModifier && (
        <Button
          data-testid='remove-nested-modifier'
          style='primary'
          responsive
          onClick={onRemoveModifier}>Remove {name}
        </Button>
      )}
    </div>
  )
}

MenuItem.propTypes = {
  nestedModifierName: PropTypes.string,
  description: PropTypes.string,
  calories: PropTypes.number,
  imageUrl: PropTypes.string,
  onRemoveModifier: PropTypes.func
}
